import React from 'react';
import { MapPin, Maximize, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { TrustBadge, TrustLevel } from './TrustBadge';
interface PlotCardProps {
  id: string;
  title: string;
  location: string;
  size: string;
  price: string;
  trustLevel: TrustLevel;
  imageUrl?: string;
}
export function PlotCard({
  id,
  title,
  location,
  size,
  price,
  trustLevel
}: PlotCardProps) {
  return <div data-testid="plot-card" data-plot-id={id} className="group border border-gray-300 bg-white p-4 flex flex-col gap-4 hover:border-gray-400 transition-colors" data-id="element-970">
      <div data-testid="plot-card-image" className="aspect-video w-full bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center text-gray-400 font-mono text-sm" data-id="element-971">
        [Plot Image Placeholder]
      </div>

      <div className="flex flex-col gap-2" data-id="element-972">
        <div className="flex justify-between items-start" data-id="element-973">
          <h3 data-testid="plot-card-title" className="font-bold text-lg text-[#1f2933] leading-tight" data-id="element-974">
            {title}
          </h3>
          <TrustBadge level={trustLevel} data-id="element-975" />
        </div>

        <div data-testid="plot-card-location" className="flex items-center gap-2 text-gray-500 text-sm font-mono" data-id="element-976">
          <MapPin className="w-4 h-4" data-id="element-977" />
          <span data-id="element-978">{location}</span>
        </div>

        <div className="grid grid-cols-2 gap-4 mt-2 py-3 border-t border-b border-dashed border-gray-200" data-id="element-979">
          <div data-testid="plot-card-size" className="flex items-center gap-2" data-id="element-980">
            <Maximize className="w-4 h-4 text-gray-400" data-id="element-981" />
            <span className="font-mono text-sm" data-id="element-982">{size}</span>
          </div>
          <div data-testid="plot-card-price" className="text-right font-bold text-[#1f2933]" data-id="element-983">
            {price}
          </div>
        </div>

        <Link data-testid="plot-card-view-details-btn" to={`/listing/${id}`} className="mt-2 inline-flex items-center justify-center gap-2 w-full py-2 border border-gray-300 bg-gray-50 text-sm font-medium text-gray-700 hover:bg-gray-100 transition-colors" data-id="element-984">
          View Details
          <ArrowRight className="w-4 h-4" data-id="element-985" />
        </Link>
      </div>
    </div>;
}